module.exports = __webpack_public_path__ + "img/lg_ring_g_c_null_1.5387f965.png";